var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Search(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27273 5.72725C1.27273 3.26705 3.26711 1.27267 5.72729 1.27267C8.18748 1.27267 10.1819 3.26705 10.1819 5.72725C10.1819 8.18744 8.18748 10.1818 5.72729 10.1818C3.26711 10.1818 1.27273 8.18744 1.27273 5.72725ZM5.72729 -6.10352e-05C2.5642 -6.10352e-05 0 2.56414 0 5.72725C0 8.89035 2.5642 11.4546 5.72729 11.4546C8.89039 11.4546 11.4546 8.89035 11.4546 5.72725C11.4546 2.56414 8.89039 -6.10352e-05 5.72729 -6.10352e-05ZM11.2681 10.3682C11.0196 10.1197 10.6167 10.1197 10.3681 10.3682C10.1196 10.6167 10.1196 11.0197 10.3681 11.2682L12.9136 13.8136C13.1621 14.0622 13.5651 14.0622 13.8136 13.8136C14.0621 13.5651 14.0621 13.1622 13.8136 12.9137L11.2681 10.3682Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Search);
export default __webpack_public_path__ + "static/media/100-search.39a0fb5b6081e18def34e370169d92a6.svg";
export { ForwardRef as ReactComponent };